import * as REDUX_TYPES from '../types'

export const resetLog = () => {
    return {
        type: REDUX_TYPES.LOG.RESET
    }
}

export const addLogMessage = (logMessage) => {
    return {
        type: REDUX_TYPES.LOG.ADD_LOG_MESSAGE,
        logMessage
    }
}
